module.exports = __webpack_public_path__ + "images/backgrounds/ocean/large.b981edeb8b6aa00c5245.jpg";